var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { RECEIVE_STAY_REQUEST_CONFIG, REQUEST_STAY_REQUEST_FOR_CONVERSATION, REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION, RECEIVE_STAY_REQUEST_FOR_CONVERSATION } from '../actions/stayRequest';
var initialStore = {
    stayRequestByConversationId: {},
    stayRequestsLoading: [],
    config: {
        nbDaysPreapprovalExpiration: 4,
        nbDaysToAutoDecline: 4
    }
};
var stayRequest = function (state, action) {
    var _a;
    if (state === void 0) { state = initialStore; }
    switch (action.type) {
        case RECEIVE_STAY_REQUEST_CONFIG:
            return Object.assign({}, state, __assign(__assign({}, state), { config: {
                    nbDaysPreapprovalExpiration: action.nbDaysPreapprobationExpiration,
                    nbDaysToAutoDecline: action.nbDaysToAutoDecline
                } }));
        case REQUEST_STAY_REQUEST_FOR_CONVERSATION:
            return Object.assign({}, state, {
                stayRequestsLoading: __spreadArray(__spreadArray([], state.stayRequestsLoading, true), [action.id], false)
            });
        case RECEIVE_STAY_REQUEST_FOR_CONVERSATION:
            return Object.assign({}, state, __assign(__assign({}, state), { stayRequestByConversationId: __assign(__assign({}, state.stayRequestByConversationId), (_a = {}, _a[action.id] = action.stayRequest, _a)) }));
        case REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION:
            return Object.assign({}, state, {
                stayRequestsLoading: state.stayRequestsLoading.filter(function (id) { return id !== action.id; })
            });
        default:
            return state;
    }
};
export default stayRequest;
